// extracted by mini-css-extract-plugin
module.exports = {"topBanner":"doctorAgreementBanner_topBanner__tAznn","bannerContent":"doctorAgreementBanner_bannerContent__1Uhfp"};